var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDotNet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Microsoft_.NET_logo",
    transform: "translate(0.425 0.425)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1918",
    "data-name": "Rectangle 1918",
    width: 52,
    height: 52,
    transform: "translate(-0.425 -0.425)",
    fill: "#512bd4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19559",
    "data-name": "Path 19559",
    d: "M70.967,271.519a1.287,1.287,0,0,1-.921-.361,1.22,1.22,0,0,1,0-1.769,1.342,1.342,0,0,1,1.851,0,1.2,1.2,0,0,1,0,1.769A1.3,1.3,0,0,1,70.967,271.519Z",
    transform: "translate(-62.091 -239.108)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19560",
    "data-name": "Path 19560",
    d: "M123.131,184.278h-2.348l-6.186-9.76a4.367,4.367,0,0,1-.388-.769h-.054a14.011,14.011,0,0,1,.072,1.824v8.7h-2.077V171h2.5l5.979,9.528q.379.593.488.815h.036a12.1,12.1,0,0,1-.09-1.787V171h2.068Z",
    transform: "translate(-99.813 -152.071)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19561",
    "data-name": "Path 19561",
    d: "M242.831,184.278h-7.27V171h6.981v1.87H237.71v3.759h4.452v1.861H237.71v3.926h5.12Z",
    transform: "translate(-209.398 -152.071)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19562",
    "data-name": "Path 19562",
    d: "M316.725,172.87H313v11.408h-2.149V172.87h-3.712V171h9.582Z",
    transform: "translate(-272.96 -152.071)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotNet);
export default __webpack_public_path__ + "static/media/dotNet.79d1f982ac48dd43e2bd21ed5934f66a.svg";
export { ForwardRef as ReactComponent };